export const TRANSLATION = {
  ru: {
    text: 'Мы&nbsp;используем файлы cookie, чтобы улучшить ваше пребывание на&nbsp;нашем сайте. Используя наш сайт, вы&nbsp;соглашаетесь на&nbsp;использование файлов cookie'
  }
}